const formatter = {
    capitalizeFirstLetter: (string: string) => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase(),
    formatLocationName: (string: string) => string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, '_')
};

export default formatter;